module.exports = __webpack_public_path__ + "img/ziel_frankfurt.f0e99fdb.png";